import { useState } from 'react'
import { mutations } from '../../resources'
import { generateError } from '../../helpers/errors'
import { useDispatch } from '../redux'
import { NewsModel } from '../../models'
import { ShareNewsRequest } from '../../resources/news/types'
import APIError from '../../resources/error'
import { AxiosError } from 'axios'
import actions from '../../store/actions'

export const useNewsShare = (
    onFacebookError: (error: APIError) => void = () => {},
    onGoogleError: (error: APIError) => void = () => {},
    onInstagramError: (error: APIError) => void = () => {},
    onTwitterError: (error: APIError) => void = () => {},
) => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)
    const [facebookInProgress, setFacebookInProgress] = useState(false)
    const [googleInProgress, setGoogleInProgress] = useState(false)
    const [instagramInProgress, setInstagramInProgress] = useState(false)
    const [twitterInProgress, setTwitterInProgress] = useState(false)

    const shareNews = (payload: ShareNewsRequest): Promise<NewsModel> => {
        setInProgress(true)

        return mutations
            .shareNews(
                payload,
                setFacebookInProgress,
                setGoogleInProgress,
                setInstagramInProgress,
                setTwitterInProgress,
                (error: AxiosError) => onFacebookError(generateError(error)),
                (error: AxiosError) => onGoogleError(generateError(error)),
                (error: AxiosError) => onInstagramError(generateError(error)),
                (error: AxiosError) => onTwitterError(generateError(error)),
            )
            .then((response) => {
                setInProgress(false)
                dispatch(actions.setNews(response))
                return response
            })
            .catch((error) => {
                setInProgress(false)
                setFacebookInProgress(false)
                setGoogleInProgress(false)
                setInstagramInProgress(false)
                setTwitterInProgress(false)
                throw generateError(error)
            })
    }

    return {
        shareNews,
        inProgress,
        facebookInProgress,
        instagramInProgress,
        twitterInProgress,
        googleInProgress,
    }
}
